import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPresentationMode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 41,
	viewBox: "0 0 41 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.1667 13H14.6667C14.2246 13 13.8007 13.1756 13.4882 13.4882C13.1756 13.8007 13 14.2246 13 14.6667V17.1667M28 17.1667V14.6667C28 14.2246 27.8244 13.8007 27.5118 13.4882C27.1993 13.1756 26.7754 13 26.3333 13H23.8333M23.8333 28H26.3333C26.7754 28 27.1993 27.8244 27.5118 27.5118C27.8244 27.1993 28 26.7754 28 26.3333V23.8333M13 23.8333V26.3333C13 26.7754 13.1756 27.1993 13.4882 27.5118C13.8007 27.8244 14.2246 28 14.6667 28H17.1667",
		stroke: "#50566E",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPresentationMode;
